import { render, staticRenderFns } from "./VueInput.vue?vue&type=template&id=45e3d122&"
import script from "./VueInput.vue?vue&type=script&lang=js&"
export * from "./VueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports